module.exports = __webpack_public_path__ + "img/Hawaiian Poke Wrap-Tofu.b42f0ee7.jpg";